import api from "@/tools/Api";
import urls from "@/tools/Urls";
import store from "@/store";
import message from "@/tools/Message";

export default {
  async createCert(payload) {
    try {
      const res = await api.post(urls.api("post_cert"), payload);
      if (res.isSuccess) message.success("CREATE_SUCCESS");
      return res;
    } catch (e) {
      message.error(e.message);
      console.log(e);
      return e;
    }
  },
  async getCerts(schema) {
    try {
      const { data } = await api.post(urls.api("get_certs"), schema);
      await store.dispatch("dashboard/setCerts", data.data);
      await store.dispatch("pagination/setItemsLength", data.totalCount);
      return data;
    } catch (e) {
      console.log(e);
      return e;
    }
  },
  async editCert(payload, id) {
    try {
      const res = await api.post(urls.api("edit_cert"), {
        ...payload,
        certificateId: id,
      });
      console.log(res);
      if (res.isSuccess) message.success("UPDATE_SUCCESS");
      return res;
    } catch (e) {
      message.error(e.response.data.Message);
      console.log(e);
      return e;
    }
  },
  async getSingleCert(id) {
    try {
      const data = await api.get(urls.api("get_cert", [id]));
      await store.dispatch("dashboard/setCert", data.data);
      return data;
    } catch (e) {
      console.log(e);
    }
  },
  async addPayToCert(payload) {
    try {
      const res = await api.post(urls.api("add_payment"), payload);
      if (res) message.success("ADD_SUCCESS");
      return res;
    } catch (e) {
      message.error("مشکلی پیش آمده");
      console.log(e);
    }
  },
  async acceptCertificate(payload) {
    try {
      const { data } = await api.post(urls.api("accept_certificate"), payload);
      return data;
    } catch (e) {
      console.log(e);
      return e;
    }
  },
  async rejectCertificate(payload) {
    try {
      const { data } = await api.post(urls.api("reject_certificate"), payload);
      return data;
    } catch (e) {
      console.log(e);
    }
  },
  async changePassword(payload) {
    try {
      return await api.post(urls.api("reset_password"), payload);
    } catch (e) {
      message.error(e.response.data.Message);
      console.log(e);
      return e;
    }
  },
};
